<template>
	<div class="gvf">
		<v-menu
			:close-on-click="true"
			:close-on-content-click="false"
			:open-on-focus="true"
			offset-y
			v-model="menuStatus"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-text-field
					:disabled="isNull"
					:tabindex="tabIndex"
					v-model="selectedUserText"
					clearable
					v-bind="attrs"
					v-on="on"
					:label="gridViewField.Label"
					hide-details="auto"
					@click:clear="onClear"
				>
					<template v-slot:append>
						<v-icon v-if="menuStatus">mdi-menu-up</v-icon>
						<v-icon v-else class="rotate">mdi-menu-up</v-icon>
					</template>
				</v-text-field>
			</template>
			<div v-if="menuStatus" style="background-color: white">
				<v-overlay absolute="absolute" :value="loading" :dark="false">
					<v-card max-width="200px">
						<v-card-text class="d-flex justify-center">
							<v-progress-circular
								:size="25"
								indeterminate
								color="primary"
							/>
							<span class="mx-3 text-button">Loading</span>
						</v-card-text>
					</v-card>
				</v-overlay>
				<v-row no-gutters class="mx-5" style="align-items: flex-end">
					<v-text-field
						@click:clear="onSearchClear"
						v-debounce:1000ms="onSearchChanged"
						append-icon="mdi-magnify"
						clearable
						v-model="search"
						hide-details="true"
						label="Search"
					></v-text-field>
				</v-row>

				<v-list max-height="300" style="overflow-y: scroll">
					<v-list-item-group
						v-model="selectedUser"
						active-class="primary white--text"
						class="field-list"
					>
						<v-list-item
							v-for="(item, index) in allUsers"
							@click.prevent="onSelectItem(item)"
							:key="index"
							:value="item"
							><v-list-item-content>
								<v-list-item-title>
									<span
										>{{ item.FirstName }}
										{{ item.LastName }}
									</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</div>
		</v-menu>
		<v-checkbox
			v-if="isBulkEdit"
			v-model="isNull"
			label="Set field to null"
			class="ma-0"
			hide-details
			@change="changeValue()"
		></v-checkbox>
	</div>
</template>
<script>
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
import gridViewFieldsUtils from '../../../../utils/gridViewFieldsUtils';
import dataService from '../../../../services/data/projectGridsService';
import { GeneralActions } from '../../../../store/actions';

export default {
	name: 'UserField',
	mixins: [gridFieldMixin],
	data() {
		return {
			menuStatus: false,
			value: null,
			selectedUser: null,
			selectedUserText: null,
			allUsers: [],
			loading: false,
			search: '',
		};
	},
	mounted() {
		if (this.record && this.key && this.record[this.key]) {
			this.value = this.record[this.key];
		}
		if (this.value != null) {
			this.loading = true;
			dataService
				.loadUserById(this.value)
				.then((response) => {
					this.selectedUser = response.data;
					this.selectedText(response.data);
					this.loading = false;
				})
				.catch((error) => {
					this.$store.dispatch(GeneralActions.ERROR, error);
					this.loading = false;
				});
		}
	},
	watch: {
		menuStatus(newVal) {
			if (!newVal) {
				this.search = null;
				return;
			}
			if (this.search === null) this.onSearchChanged();
		},
	},
	methods: {
		selectedText(item) {
			this.selectedUserText = item.FirstName.toString().concat(
				' ',
				item.LastName.toString()
			);
		},

		onSelectItem(selectedRow) {
			this.selectedUser = selectedRow;
			this.selectedText(selectedRow);
			this.changeValue();
			this.menuStatus = false;
		},
		onSearchChanged() {
			this.loading = true;
			dataService
				.loadUsers(this.search)
				.then((response) => {
					this.allUsers = response.data;
					this.loading = false;
				})
				.catch((error) => {
					this.loading = false;
					this.$store.dispatch(GeneralActions.ERROR, error);
				});
		},
		changeValue() {
			let recordKey;
			if (this.isNull) {
				recordKey = [{ key: this.key, value: null }];
				this.value = null;
			} else {
				recordKey = [{ key: this.key, value: this.value }];
			}
			let itemKey = [
				{
					key: gridViewFieldsUtils.getFieldName(this.gridViewField),
					value: this.value,
				},
			];
			this.$emit('valueChanged', itemKey, recordKey, this.isNull);
		},
		onClear() {
			this.selectedUser = null;
		},
		onSearchClear() {
			this.search = null;
			this.onSearchChanged();
		},
	},
};
</script>

<style lang="scss">
.rotate {
	transform: rotate(180deg);
}
.v-menu__content {
	background-color: white;
}
</style>
